<section class="cms-page">
  <header class="admin-header">
    <div>
      <h1>Website Content</h1>
      <p>Edit public website copy without changing code.</p>
    </div>

    <button type="button" class="ghost-button" (click)="seedDefaults()" [disabled]="isSaving || isSeeding">
      {{ isSeeding ? 'Seeding...' : 'Seed Missing Defaults' }}
    </button>
  </header>

  <div class="status success" *ngIf="successMessage">{{ successMessage }}</div>
  <div class="status error" *ngIf="errorMessage">{{ errorMessage }}</div>

  <nav class="content-tabs" aria-label="Website content sections">
    <button
      *ngFor="let tab of tabs; trackBy: trackByTab"
      type="button"
      [class.active]="activeTab === tab.id"
      (click)="setActiveTab(tab.id)"
    >
      {{ tab.label }}
    </button>
  </nav>

  <section class="editor-card">
    <form *ngIf="activeTab === 'hero'" [formGroup]="heroForm" class="content-form">
      <label>Eyebrow <input type="text" formControlName="eyebrow" /></label>
      <label>Headline <input type="text" formControlName="headline" /></label>
      <label>Sub headline <input type="text" formControlName="subHeadline" /></label>
      <label>Description <textarea rows="4" formControlName="description"></textarea></label>
      <label>Primary button text <input type="text" formControlName="primaryButtonText" /></label>
      <label>Secondary button text <input type="text" formControlName="secondaryButtonText" /></label>
      <label>Hero image URL <input type="text" formControlName="heroImageUrl" /></label>
    </form>

    <form *ngIf="activeTab === 'journey'" [formGroup]="journeyForm" class="content-form">
      <label>Eyebrow <input type="text" formControlName="eyebrow" /></label>
      <label>Title <input type="text" formControlName="title" /></label>
      <label>Description <textarea rows="4" formControlName="description"></textarea></label>
      <label>Button text <input type="text" formControlName="buttonText" /></label>

      <div class="array-fields" formArrayName="steps">
        <h2>Journey Steps</h2>
        <label *ngFor="let step of journeySteps.controls; let i = index; trackBy: trackByIndex">
          Step {{ i + 1 }}
          <input type="text" [formControlName]="i" />
        </label>
      </div>
    </form>

    <form *ngIf="activeTab === 'productsPage'" [formGroup]="productsPageForm" class="content-form">
      <label>Eyebrow <input type="text" formControlName="eyebrow" /></label>
      <label>Headline <input type="text" formControlName="headline" /></label>
      <label>Description <textarea rows="4" formControlName="description"></textarea></label>
    </form>

    <form *ngIf="activeTab === 'whyChooseUs'" [formGroup]="whyChooseUsForm" class="content-form">
      <label>Eyebrow <input type="text" formControlName="eyebrow" /></label>
      <label>Title <input type="text" formControlName="title" /></label>
      <label>Description <textarea rows="4" formControlName="description"></textarea></label>
    </form>

    <form *ngIf="activeTab === 'impactStats'" [formGroup]="impactStatsForm" class="content-form">
      <label>Title <input type="text" formControlName="title" /></label>

      <div class="stats-editor" formArrayName="stats">
        <article
          *ngFor="let stat of impactStats.controls; let i = index; trackBy: trackByIndex"
          [formGroupName]="i"
        >
          <h2>Stat {{ i + 1 }}</h2>
          <label>Value <input type="text" formControlName="value" /></label>
          <label>Label <input type="text" formControlName="label" /></label>
        </article>
      </div>
    </form>

    <form *ngIf="activeTab === 'footer'" [formGroup]="footerForm" class="content-form">
      <label>Company description <textarea rows="4" formControlName="companyDescription"></textarea></label>
      <label>Phone <input type="text" formControlName="phone" /></label>
      <label>Email <input type="email" formControlName="email" /></label>
      <label>Address <textarea rows="3" formControlName="address"></textarea></label>
      <label>Facebook <input type="url" formControlName="facebook" /></label>
      <label>Instagram <input type="url" formControlName="instagram" /></label>
      <label>LinkedIn <input type="url" formControlName="linkedin" /></label>
      <label>YouTube <input type="url" formControlName="youtube" /></label>
    </form>

    <footer class="editor-actions">
      <button type="button" class="ghost-button" (click)="resetActiveSection()" [disabled]="isSaving">
        Reset to Fallback
      </button>
      <button type="button" class="primary-button" (click)="saveActiveSection()" [disabled]="isSaving">
        {{ isSaving ? 'Saving...' : 'Save Changes' }}
      </button>
    </footer>
  </section>
</section>
